import { renderDrawerHeader_unstable } from '@fluentui/react-drawer';

/**
 * Renders the final JSX of the DrawerHeader component, given the state.
 */
export const renderDrawerHeader = renderDrawerHeader_unstable;
